const Style = {

  header: 'pb-4 mb-4',
  label: 'text-text-muted text-sm',

}

export default Style;